import { Box } from '@factorialco/deprecated-design-system'
import { Widget } from '@factorialco/f0-react/dist/experimental'
import { isEmpty } from 'lodash'

import i18n from 'modules/core/lib/i18n'

import { Expensable } from 'modules/expenses/types/Expensable'

import { CustomTwoColumnsList } from '../CustomTwoColumnList'
import CustomWidgetHeaderButton from './CustomWidgetHeaderButton'

interface BudgetAndProjectWidgetProps {
  expensable: Expensable
  editable: boolean
  onEdit: () => void
}

const buildBudgetAndProjectListData = (expensable: Expensable) => {
  const budget = expensable?.bugdetMovement?.budget?.name || ''
  const project = expensable?.projects?.[0]?.projectWorker?.imputableProject?.name || ''
  const subproject = expensable?.projects?.[0]?.subproject?.name || ''

  const items = [
    {
      title: i18n.t('expenses_v2.confirmation_screen.expense.budget_and_project_block.budget'),
      info: budget,
    },
    {
      title: i18n.t('expenses_v2.confirmation_screen.expense.budget_and_project_block.project'),
      info: project,
    },
    {
      title: i18n.t('expenses_v2.confirmation_screen.expense.budget_and_project_block.subproject'),
      info: subproject,
    },
  ]

  return items.filter(({ info }) => !isEmpty(info))
}

const BudgetAndProjectWidget = ({ expensable, editable, onEdit }: BudgetAndProjectWidgetProps) => {
  const list = buildBudgetAndProjectListData(expensable)

  if (isEmpty(list)) {
    return null
  }

  return (
    <Box gap="s16" position="relative">
      <Widget
        header={{
          title: i18n.t('expenses_v2.confirmation_screen.expense.budget_and_project_block.title'),
        }}
      >
        <CustomTwoColumnsList list={list} />
      </Widget>
      {editable && (
        <CustomWidgetHeaderButton
          label={i18n.t('expenses_v2.confirmation_screen.confirmation_screen_block_edit_action')}
          onClick={onEdit}
        />
      )}
    </Box>
  )
}

export default BudgetAndProjectWidget
